import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m14.854 7.354-5 5A.5.5 0 0 1 9 12V9.515c-3.569.202-6.016 2.516-6.703 3.25a.75.75 0 0 1-1.292-.6c.232-2.015 1.336-3.955 3.11-5.46C5.588 5.455 7.379 4.662 9 4.523V2a.5.5 0 0 1 .854-.354l5 5a.5.5 0 0 1 0 .708"
    }, null, -1)
  ])))
}
export default { render: render }